import styled, { css } from "styled-components";
import tokens from "../../theme/tokens";

const toneStyles = {
  high: css`
    color: ${tokens.confidence.high.fg};
    background: ${tokens.confidence.high.bg};
    border-color: ${tokens.confidence.high.border};
  `,
  medium: css`
    color: ${tokens.confidence.medium.fg};
    background: ${tokens.confidence.medium.bg};
    border-color: ${tokens.confidence.medium.border};
  `,
  low: css`
    color: ${tokens.confidence.low.fg};
    background: ${tokens.confidence.low.bg};
    border-color: ${tokens.confidence.low.border};
  `,
};

const sizeStyles = {
  sm: css`
    font-size: 11px;
    padding: 2px 7px;
    height: 20px;
  `,
  md: css`
    font-size: 12px;
    padding: 3px 9px;
    height: 24px;
  `,
};

export const PillRoot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-family: ${tokens.typography.fontFamily};
  font-weight: ${tokens.typography.weight.semibold};
  line-height: 1;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;

  ${(p) => sizeStyles[p.$size] || sizeStyles.sm}
  ${(p) => toneStyles[p.$tone] || toneStyles.medium}
`;
